var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTask = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6780AA",
  fillRule: "evenodd",
  d: "m21.528 11.072 1.488 1.512-6.984 7.032-4.536-4.512 1.488-1.488 3.048 3zM2.016 15.584v-1.968h7.968v1.968zm12-9.984v2.016h-12V5.6zm0 3.984V11.6h-12V9.584z"
})));
export default SvgTask;